import Popup from "reactjs-popup";
import OTPInputField from "../../ui/CustomOtpInput/OTPInputField";
import { useState } from "react";
import Loader from "../../shared/Loader";
import { toast } from "react-toastify";
import {
  useActive2faViaGoogleAuth,
  useConfirmOtp2faViaGoogleAuth,
} from "../../lib/queries/queriesAndMutations";
import { useQueryClient } from "@tanstack/react-query";
import RadioBtn from "../../shared/RadioBtn";

const ActiveGoogleAuthModalBtn = ({
  feildIsActive,
  onFactorSetiingIsActive,
}) => {
  const [code, setCode] = useState("");
  const [qrCode, setQrCode] = useState("");
  const { mutateAsync: activeViaGoogleAuth } = useActive2faViaGoogleAuth("");
  const { mutateAsync: confirmOtp, isPending } =
    useConfirmOtp2faViaGoogleAuth("");
  const queryClient = useQueryClient();

  const handleSendGoogleAuth = async (active) => {
    //console.log("handleSendSms run");
    try {
      const response = await activeViaGoogleAuth(active);
      setQrCode(response?.data?.qr_code);
      //console.log({ response });
    } catch (error) {
      //console.log({ error });
    }
  };
  const handleConfirmOtp = async ({ close, feildIsActive }) => {
    //console.log("handleSendSms run");
    try {
      const response = await confirmOtp({ otp: code, active: !feildIsActive });
      if (response.status === 200) {
        toast.success("عملیات موفق");
        queryClient.invalidateQueries({ queryKey: ["getProfile"] });
        setCode("");
        close();
      }
      //console.log({ response });
    } catch (error) {
      //console.log({ error });
    }
  };

  return (
    <Popup
      onOpen={() => handleSendGoogleAuth(!feildIsActive)}
      trigger={
        feildIsActive ? (
          <RadioBtn checked={true} onClick={() => {}} />
        ) : onFactorSetiingIsActive ? null : (
          <RadioBtn checked={false} onClick={() => {}} />
        )
      }
      modal
      nested
    >
      {(close) => (
        <div
          className="modal-wrapper "
          dir="rtl"
        >
          <p className="text-[16px] font-semibold">
            اپلیکیشن Google Authenticator را باز کنید
          </p>
          <p className="text-[16px] ">
            لطفاً کد تأیید ارسال‌شده به Google Authenticator خود را وارد کنید تا
            امکان فعال‌سازی احراز هویت دو مرحله‌ای فراهم شود.
          </p>

          <img src={qrCode} alt="" className="w-full" />

          <div className="w-full flex justify-center " dir="ltr">
            <OTPInputField
              value={code}
              handleChange={setCode}
              numOfInputs={6}
            />
          </div>

          <div className="flex mr-auto gap-1 mt-8">
            <button
              onClick={close}
              className="secondary-btn"
              disabled={isPending}
            >
              انصراف
            </button>
            <button
              onClick={() => handleConfirmOtp({ close, feildIsActive })}
              className="primary-btn"
              disabled={isPending}
            >
              {isPending ? (
                <div className="w-8 h-8 mx-auto">
                  <Loader />
                </div>
              ) : (
                "تایید کد"
              )}
            </button>
          </div>
        </div>
      )}
    </Popup>
  );
};

export default ActiveGoogleAuthModalBtn;
